import React, { useContext, useEffect } from 'react';
import { DefaultAlert, alertTypeData } from '@luigiclaudio/ga-baseline-ui/alert';
import { GaIcon } from '@luigiclaudio/ga-baseline-ui/icon';
import { H6 } from '@luigiclaudio/ga-baseline-ui/typography';
import styled from 'styled-components';
import Container from './Container';
import CopiedAlertContentContainer from './CopiedAlertContentContainer';
import CopiedIcon from './CopiedIcon';
import FeedbackContext from '../FeedbackContext';

const FeedbackLabel = styled(H6)`
    color: inherit;
`;

const FeedbackContainer = () => {
    const { feedbackOnStage, setFeedbackOnStage } = useContext(FeedbackContext);

    const { label, type, show, icon, offsetTop, timeout } = feedbackOnStage;

    useEffect(() => {
        const timer = setTimeout(() => {
            if (show) {
                setFeedbackOnStage({ ...feedbackOnStage, show: false });
            }
        }, timeout || 2400);
        return () => clearTimeout(timer);
    }, [feedbackOnStage]);

    const alertType = alertTypeData.includes(type) ? type : undefined;

    return (
        <Container offsetTop={offsetTop}>
            <DefaultAlert
                inProp={show}
                appear
                mountOnEnter
                unmountOnExit
                alertType={alertType}
                showShadow
            >
                <CopiedAlertContentContainer>
                    {icon && (
                        <CopiedIcon>
                            <GaIcon icon={icon} size={18} color="currentColor" />
                        </CopiedIcon>
                    )}
                    <FeedbackLabel>{label}</FeedbackLabel>
                </CopiedAlertContentContainer>
            </DefaultAlert>
        </Container>
    );
};

export default FeedbackContainer;
